import { Module } from 'vuex'

interface SolvedProblemsState {
  chartData: { labelChartData: number[]; dailyTotalChartData: number[][]; maxTotal: number }
  chartSeries: any[]
  chartOptions: any
  hasData: boolean
}

export const solvedProblemsModule = (): Module<SolvedProblemsState, any> => {
  return {
    namespaced: true,
    state: {
      chartData: { labelChartData: [], dailyTotalChartData: [], maxTotal: 0 },
      chartSeries: [],
      chartOptions: {},
      hasData: false
    },
    mutations: {
      setChartData(state, chartData: { labelChartData: number[]; dailyTotalChartData: number[][]; maxTotal: number }) {
        state.chartData = chartData
      },
      setChartSeries(state, chartSeries: any[]) {
        state.chartSeries = chartSeries
      },
      setChartOptions(state, chartOptions: any) {
        state.chartOptions = chartOptions
      },
      setHasData(state, hasData: boolean) {
        state.hasData = hasData
      }
    },
    actions: {},
    getters: {
      chartData: state => state.chartData,
      chartSeries: state => state.chartSeries,
      chartOptions: state => state.chartOptions,
      hasData: state => state.hasData
    }
  }
}
